<template>
    <div class="card border-0 justify-content-center" style="background-color: #ecf0f1">
        <div class="card-body rounded" style="background-color: #ecf0f1"> 
            <div class="text-center"><img  src="/assets/img/online-banking1.png" width="80px"  height="80px" style=" opacity: 0.5;">
            <h6 class="mt-1 s-8 font-weight-bold text-green">Edit Bank<br><small> </small></h6></div>
            <form @submit.prevent="editBank">
                <div class="card no-b  no-r">
                    <div class="card-body no-gutters" style="background-color: #ecf0f1">
                        <div class="form-row mb-3">

                            <div class="col-md-12">
                                <div>Currency : {{ bank.currency_code }}</div><br>
                                <div class="input-group mt-3 mb-3">
                                    
                                    <div class="input-group-prepend">
                                        <div class="input-group-text" style="background-color: #2E671A; border:1px solid #2E671A !important">
                                            <i class="icon icon-currency float-left s-20 text-white"></i>
                                        </div>
                                    </div>
                                    
                                    <select id="country-select" @change="setCurrency" class="form-control r-1 light s-5" style="background-color:transparent; ; border: 2px solid #2E671A;">
                                        <option :value="''" >Select country</option>
                                        <option v-for="country,i in countries" :value="country" :key="i">{{ country.split('|')[0] }}</option>              
                                    </select>	
                                </div> 
                            </div>  

                            <template v-if="selectedCurrency == 'NGN' || selectedCurrency == null">
                                <div class="col-md-12">
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="icon icon-card_membership float-left s-20 text-white " ></i></div>
                                        </div>
                                        <input v-model="form.bank_name" type="text" class="form-control r-0 light s-12" id="inlineFormInputGroupUsername2"
                                                placeholder="Bank name" style="border: 1px solid #2E671A; background-color: #ded8c7;">
                                    </div>
                                    <div class="input-group mr-sm-2 mt-3 mb-3">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="icon icon-sitemap float-left s-20 text-white " ></i></div>
                                        </div>
                                        <input v-model="form.bank_account_name" type="text" class="form-control r-0 light s-12" id="inlineFormInputGroupUsername2"
                                                placeholder="Bank account name" style="border: 1px solid #2E671A; background-color: #ded8c7;">
                                    </div>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text"><i class="icon icon-credit-card float-left s-20 text-white  " ></i></div>
                                        </div>
                                        <input v-model="form.bank_account_number" type="text" class="form-control r-0 light s-12" id="inlineFormInputGroupUsername2"
                                                placeholder="bank account number" style="border: 1px solid #2E671A; background-color: #ded8c7;">
                                    </div>
                                </div>
                            </template>

                            <template v-else>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text" style="background-color: #2E671A"><i class="icon icon-account_balance float-left s-20 text-white" ></i></div>
                                    </div>
                                    <select id="operator-select" @change="setMobileOperator" v-model="form.bank_name" required class="form-control r-1 light s-5" style="background-color:transparent; ; border: 2px solid #2E671A;">
                                        <option :value="'Startwins'" style="background-color: #ecf0f1;">Select Operator</option>
                                        <option v-for="operator,i in mobileMoneyOperators" :value="operator.slug" :key="i" style="background-color: #ecf0f1">{{ operator.name }}
                                        </option>														   
                                    </select>	   
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend" >
                                        <div class="input-group-text" style="background-color: #2E671A"><i class="icon icon-account_balance float-left s-20 text-white " ></i></div>
                                    </div>
                                    <input v-model="form.bank_account_number" required type="text" min="10" class="form-control r-1 light s-12" placeholder="Mobile No." style="background-color:transparent; ; border: 2px solid #2E671A;"> 
                                </div>  
                                <input v-model="form.bank_code" required type="hidden" min="10" class="form-control r-1 light s-12" placeholder="Account No." style="background-color:transparent; ; border: 2px solid #2E671A;"> 
                            </template>

                        </div>
                        <span class="btn btn-sm btn-success btn-lg" v-if="editingBank">...</span>
                        <button v-else type="submit" class="btn btn-sm btn-success btn-lg"><i class="icon-save mr-2"></i>Update Data</button>
                    </div>	
                </div>
            </form>
        </div>
    </div> 
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

 export default{
    name:"edit-bank",

    props:{
        bank:{
            type:Object,
            required:true
        }
    },

    data(){
        return{
            form:{
                bank_name:this.bank.bank_name,
                bank_account_name:this.bank.bank_account_name,
                bank_account_number:this.bank.bank_account_number,
                currency_code:this.bank.currency_code
            },
            editingBank:false,
            //countries : ['Nigeria|NGN','Cameroon|XAF','Kenya|KHS'],
            selectedCurrency : null,
            mobileMoneyOperators:[],
        }
    },

    computed:{
        ...mapState({
            submitting:state=>state.submitting
        }),

        ...mapGetters('userStore',['countries']),
    },

    created(){
        this.form.bank_name = this.bank.bank_name
        this.form.bank_account_name = this.bank.bank_account_name
        this.form.bank_account_number = this.bank.bank_account_number

        this.selectedCurrency = this.bank.currency_code ?? 'NGN'

        if(this.selectedCurrency !== 'NGN'){
            this.fetchMobileMoneyOperators(this.selectedCurrency).then(res=>{
                if(res && res.status == 200){
                    this.mobileMoneyOperators = res.data.data
                }
            })
        }
        

        
    },

    methods:{
        ...mapActions('bankStore',['updateBank']),
        ...mapActions('paymentStore',['fetchBanks','fetchMobileMoneyOperators']),
        

        editBank(){
            this.editingBank = true
            this.updateBank({id:this.bank.id,data:this.form}).then(res=>{
                if(res && res.status == 200){
                    this.$emit('updated')
                }
                this.editingBank = false
            })
        },

        setCurrency(e){
            //var ele = document.getElementById('country-select')
            //var val = ele.value
            let currency = e.target.value
            this.form.currency_code = currency.split('|')[1]
            //alert(currency.split('|')[1])
            this.selectedCurrency = currency.split('|')[1]
        },

        setMobileOperator(){
            var ele = document.getElementById('operator-select')
            var val = ele.value??''
            let operator =  this.mobileMoneyOperators.find((ele)=>ele.slug == val)
            if(operator ==! -1){
                this.form.bank_code = operator.slug
                this.form.bank_name = operator.slug
            }
            
        },
    }
 }
</script>